import { render, staticRenderFns } from "./CmhModalPartners.vue?vue&type=template&id=3afd665d&scoped=true"
import script from "./CmhModalPartners.vue?vue&type=script&lang=ts"
export * from "./CmhModalPartners.vue?vue&type=script&lang=ts"
import style0 from "./CmhModalPartners.vue?vue&type=style&index=0&id=3afd665d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afd665d",
  null
  
)

export default component.exports